import { gql } from '@apollo/client';
import { DatasetEditProps } from 'types/Forms';

interface UpdateDatasetProps {
    datasetUri: string;
    input: DatasetEditProps;
}
const updateDataset = ({ datasetUri, input }: UpdateDatasetProps) => {
    return {
        variables: {
            datasetUri,
            input,
        },
        mutation: gql`
            mutation UpdateDataset(
                $datasetUri: String
                $input: ModifyDatasetInput
            ) {
                updateDataset(datasetUri: $datasetUri, input: $input) {
                    label
                    description
                    tags
                    businessOwnerEmail
                    businessOwnerDelegationEmails
                    enableCrawler
                    enableReadTrail
                    datasetStageOptions
                }
            }
        `,
    };
};

export default updateDataset;
